// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import {
  NewsThemeInfoResponseDTO,
  NewsThemePatchDTO,
  NewsThemeWriteRequestDTO
} from "../../api/backend-openapi";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import {
  restCreationHandler,
  restDecreaseOrderHandler,
  restDeletionHandler,
  restDetailsHandler,
  restFieldUpdateHandler,
  restIncreaseOrderHandler,
  restListHandler,
  restUnpublishHandler,
  restUpdateHandler
} from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;
const newsUrl = baseUrl + "/newsThemes/";

export const requestGetNewsThemes = createEffect({
  handler: restListHandler<NewsThemeInfoResponseDTO>(newsUrl)
});
export const requestGetNewsTheme = createEffect({
  handler: restDetailsHandler<NewsThemeInfoResponseDTO>(newsUrl)
});
export const requestCreateNewsTheme = createEffect({
  handler: restCreationHandler<
    NewsThemeWriteRequestDTO,
    NewsThemeInfoResponseDTO
  >(newsUrl)
});
export const requestUpdateNewsTheme = createEffect({
  handler: restUpdateHandler<
    NewsThemeWriteRequestDTO,
    NewsThemeInfoResponseDTO
  >(newsUrl)
});
export const requestUnpublishNewsTheme = createEffect({
  handler: restUnpublishHandler<
    { published: boolean },
    NewsThemeInfoResponseDTO
  >(newsUrl)
});
export const requestDeleteNewsTheme = createEffect({
  handler: restDeletionHandler<NewsThemeInfoResponseDTO>(newsUrl)
});
export const requestWorkflowNewsTheme = createEffect({
  handler: restFieldUpdateHandler<NewsThemePatchDTO, NewsThemeInfoResponseDTO>(
    newsUrl
  )
});
export const requestIncreaseOrderNewsTheme = createEffect({
  handler: restIncreaseOrderHandler<NewsThemeInfoResponseDTO>(newsUrl)
});
export const requestDecreaseOrderNewsTheme = createEffect({
  handler: restDecreaseOrderHandler<NewsThemeInfoResponseDTO>(newsUrl)
});
